// src/components/Sidebar.js
import React, { useEffect, useState } from 'react';
import { Drawer, IconButton } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { jwtDecode } from 'jwt-decode';



const Sidebar = () => {
  const [open, setOpen] = useState(false);
  const [user, setUser] = useState({ username: '', avatar: '' });
  const [userTags, setUserTags] = useState([]);

  useEffect(() => {
    // Obtém o token JWT do localStorage
    const token = localStorage.getItem('token');

    if (token) {
      // Decodifica o token JWT para obter as informações do usuário
      const decoded = jwtDecode(token);

      setUserTags(decoded.tags || []);

      // Aqui assumimos que o nome de usuário está no campo 'username' do token JWT
      // Verifique se o campo correto está sendo enviado no seu token
      setUser({
        username: decoded.username || 'Usuário', // Extrai o nome de login
        avatar: 'http://131.255.179.139:8080/iconsonik.png' // Simulação de um avatar, pode ser substituído
      });
    }

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'http://131.255.179.139:8080/supportApp/FormStyleBP.css';
    document.head.appendChild(link);
    const link2 = document.createElement('link');
    link2.rel = 'stylesheet';
    link2.href = 'http://131.255.179.139:8080/supportApp/searchStyles.css';
    document.head.appendChild(link2);

    return () => {
      document.head.removeChild(link);
      document.head.removeChild(link2);
    };
  }, []);

  const toggleDrawer = (openState) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setOpen(openState);
  };

  // Função para verificar se o usuário tem a tag 'admin' e dar acesso a tudo
  const hasAdminAccess = userTags.includes('admin');

  // Acesso ao Dashboard Infra: admin ou infra (permissoes vêm do localStorage quando usa auth session)
  const storedPerms = (() => {
    try {
      const p = localStorage.getItem('userPermissoes');
      return p ? JSON.parse(p) : [];
    } catch { return []; }
  })();
  const hasInfraAccess = hasAdminAccess || userTags.includes('infra') || userTags.includes('ti') || storedPerms.includes('admin') || storedPerms.includes('infra') || storedPerms.includes('ti');

  return (

    <div>
      {/* Botão para abrir a sidebar */}
      <IconButton
        edge="start"
        color="inherit"
        aria-label="menu"
        onClick={toggleDrawer(true)}
        sx={{
          position: 'absolute',
          top: '10px',
          left: '10px',
          zIndex: 1000,
          backgroundColor: 'rgba(255, 255, 255, 0)',
          borderRadius: '50%',
          color: 'white',
        }}
      >
        <MenuIcon />
      </IconButton>

      {/* Drawer Temporário (sidebar retrátil) */}
      <Drawer
        anchor="left"
        open={open}
        onClose={toggleDrawer(false)}
        variant="temporary"
      >
        <div
          style={{
            width: 250,
            height: '100vh', // altura total da viewport
            position: 'fixed', // fixa a div para que ela ocupe o espaço inteiro da tela
            top: 0, // garante que ela comece do topo
            left: 0, // ajusta para alinhar à esquerda
          }}
          onClick={toggleDrawer(false)}
          onKeyDown={toggleDrawer(false)}
          className="sidebar"
        >
          <div style={{ flexGrow: 1 }}>
            {/* Cabeçalho da Sidebar */}
            <div className="sidebar-header">
              <div className="app-icon">
                <img src="http://131.255.179.139:8080/soniklogo.png" alt="Company Logo" className="company-icon" />
              </div>
            </div>
            {/* Links do Menu */}
            <ul className="sidebar-list">
              <li className="sidebar-list-item">
                <a href="/dashboard">
                  <span>Home</span>
                </a>
              </li>
              {/* Se o usuário tiver a tag 'admin', exibe todos os aplicativos */}
              {hasAdminAccess && (
                <>
                  <li className="sidebar-list-item">
                    <a href="/app1">
                      <span>Logistica</span>
                    </a>
                  </li>
                  <li className="sidebar-list-item">
                    <a href="/app2">
                      <span>Suporte Apps</span>
                    </a>
                  </li>
                  <li className="sidebar-list-item">
                    <a href="/app3">
                      <span>Nextcloud Users</span>
                    </a>
                  </li>
                  <li className="sidebar-list-item">
                    <a href="/app4">
                      <span>pm2-monitor</span>
                    </a>
                  </li>
                  <li className="sidebar-list-item">
                    <a href="/app5">
                      <span>Forms</span>
                    </a>
                  </li>
                  <li className="sidebar-list-item">
                    <a href="/manage-users">
                      <span>manage-users</span>
                    </a>
                  </li>
                  <li className="sidebar-list-item">
                    <a href="/admin-painel">
                      <span>Painel Admin</span>
                    </a>
                  </li>
                  <li className="sidebar-list-item">
                    <a href="/financeiro/">
                      <span>Painel Financeiro</span>
                    </a>
                  </li>
                  <li className="sidebar-list-item">
                    <a href="/marketing/">
                      <span>Marketing Center</span>
                    </a>
                  </li>
                </>
              )}

              {/* Dashboard Infra - admin ou infra */}
              {hasInfraAccess && (
                <li className="sidebar-list-item">
                  <a href="/infra/">
                    <span>Dashboard Infra</span>
                  </a>
                </li>
              )}

              {userTags.includes('logistica') && (<li className="sidebar-list-item">
                <a href="/app1">
                  <span>Logistica</span>
                </a>
              </li>
              )}

              {userTags.includes('supapp') && (<li className="sidebar-list-item">
                <a href="/app2">
                  <span>Suporte Apps</span>
                </a>
              </li>
              )}
              {userTags.includes('supapp') && (<li className="sidebar-list-item">
                <a href="/app3">
                  <span>Nextcloud Users</span>
                </a>
              </li>
              )}
              {userTags.includes('forms') && (<li className="sidebar-list-item">
                <a href="/app5">
                  <span>Forms</span>
                </a>
              </li>
              )}
              <li className="sidebar-list-item">
                <a href="/">
                  <span>Sair</span>
                </a>
              </li>
            </ul>
          </div>

          {/* Informações da Conta */}
          <div className="account-info" style={{ padding: '10px' }}>
            <div className="account-info-name">{user.username}</div>
          </div>
        </div>
      </Drawer>
    </div>


  );

};

export default Sidebar;
